module.exports = __webpack_public_path__ + "img/reference-fhv.770ee3c7.jpg";